import { render, staticRenderFns } from "./AMoney.vue?vue&type=template&id=f7db30e0&"
import script from "./AMoney.vue?vue&type=script&lang=js&"
export * from "./AMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports